import React from "react";
import { css } from "@emotion/react";
import { Heading } from "../Typography";
import Balancer from "react-wrap-balancer";

interface SpecialOfferBadgeProps {
  specialOffer?: {
    textBeforeAmount?: string;
    amountText: string;
    textAfterAmount?: string;
    amountColor?: string;
  };
}

export function SpecialOfferBadge({ specialOffer }: SpecialOfferBadgeProps) {
  // Fallback values if no specialOffer is provided
  const beforeAmount = specialOffer?.textBeforeAmount || "Special Offer";
  const amount = specialOffer?.amountText || "$19";
  const afterAmount = specialOffer?.textAfterAmount || "for your first month";
  const amountColor = specialOffer?.amountColor || "#55d278";

  return (
    <Heading
      css={css`
        display: inline;
        padding: 5px 23px;
        background-color: rgb(36, 59, 74);
        border-radius: 40px;
        line-height: 130%;
        color: white;
        font-size: 13px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      `}
    >
      <Balancer>
        {beforeAmount}{" "}
        <span
          css={css`
            color: ${amountColor};
          `}
        >
          {amount}
        </span>{" "}
        {afterAmount}
      </Balancer>
    </Heading>
  );
}

export default SpecialOfferBadge;
